// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/";
const ROOTS_ADS = "/ads";
const ROOTS_BRANDS = "/brands";
const ROOTS_COMPETITOR_ANALYTICS = "/competitor-analytics";
const ROOTS_PRODUCTS = "/products";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_COMPETITOR_ANALYSIS = "/competitor-analysis";
const ROOTS_BEST_SELLING_PRODUCTS = "/best-selling-products";
const ROOTS_TOP30_PRODUCTS = "/top30-products";
const ROOTS_SEARCH = "/search";
const ROOTS_CREATIVE_CENTER = "/creative-center";
const ROOTS_SETTINGS = "/settings";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "login"),
  register: path(ROOTS_AUTH, "register"),
  forgotPassword: path(ROOTS_AUTH, "verify-email"),
};

export const PATH_PAGE = {
  maintenance: "/maintenance",
  page403: "/403",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATH_ADS = {
  root: ROOTS_ADS,
  trending: path(ROOTS_ADS, "/trending"),
};

export const PATH_BRANDS = {
  root: ROOTS_BRANDS,
  trending: path(ROOTS_BRANDS, "/trending"),
  discover: path(ROOTS_BRANDS, "/discover"),
  addBrand: path(ROOTS_BRANDS, "/add-brand"),
  overview: (brandId: number | string | undefined) =>
    path(ROOTS_BRANDS, `/${brandId}/overview`),
  viability: (brandId: number) => path(ROOTS_BRANDS, `/${brandId}/viability`),
  reviews: (brandId: number) => path(ROOTS_BRANDS, `/${brandId}/reviews`),
  social: (brandId: number) => path(ROOTS_BRANDS, `/${brandId}/social`),
  facebookAds: (brandId: number) =>
    path(ROOTS_BRANDS, `/${brandId}/facebook-ads`),
  googleAds: (brandId: number) => path(ROOTS_BRANDS, `/${brandId}/google-ads`),
  trafficAndRevenue: (brandId: number) =>
    path(ROOTS_BRANDS, `/${brandId}/traffic-and-revenue`),
  products: (brandId: number) => path(ROOTS_BRANDS, `/${brandId}/products`),
};

export const PATH_BEST_SELLING_PRODUCTS = {
  root: ROOTS_BEST_SELLING_PRODUCTS,
  detail: (productId: number, brandId: string) =>
    path(ROOTS_BEST_SELLING_PRODUCTS, `/${brandId}/${productId}/detail`),
};

export const PATH_TOP30_PRODUCTS = {
  root: ROOTS_TOP30_PRODUCTS,
  detail: (productId: number, brandId: string) =>
    path(ROOTS_TOP30_PRODUCTS, `/${brandId}/${productId}/detail`),
};

export const PATH_PRODUCTS = {
  root: ROOTS_PRODUCTS,
  detail: (
    productVariantId: number,
    productId: number,
    brandId: number,
    shopifyId: number,
  ) =>
    path(
      ROOTS_PRODUCTS,
      `/${brandId}/${productVariantId}/${productId}/${shopifyId}/detail`,
    ),
};

export const PATH_CREATIVE_CENTER = {
  root: ROOTS_CREATIVE_CENTER,
  boards: path(ROOTS_CREATIVE_CENTER, "/boards"),
};

export const PATH_COMPETITOR_ANALYTICS = {
  root: ROOTS_COMPETITOR_ANALYTICS,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
};

export const PATH_COMPETITOR_ANALYSIS = {
  root: ROOTS_COMPETITOR_ANALYSIS,
  mapOfBrands: path(ROOTS_COMPETITOR_ANALYSIS, "/map-of-brands"),
  mapOfBrandsV2: path(ROOTS_COMPETITOR_ANALYSIS, "/map-of-brands-v2"),
  mapOfBrandsV3: path(ROOTS_COMPETITOR_ANALYSIS, "/map-of-brands-v3"),
  comparison: path(ROOTS_COMPETITOR_ANALYSIS, "/comparison"),
  myTrackedStores: path(ROOTS_COMPETITOR_ANALYSIS, "/my-tracked-stores"),
};

export const PATH_SETTINGS = {
  root: ROOTS_SETTINGS,
  general: path(ROOTS_SETTINGS, "/general"),
  plans: path(ROOTS_SETTINGS, "/plans"),
  billing: path(ROOTS_SETTINGS, "/billing"),
  security: path(ROOTS_SETTINGS, "/security"),
  profile: path(ROOTS_SETTINGS, "/profile"),
};

export const PATH_DOCS = "https://support.trendrocket.io";

export const PATH_SEARCH = {
  root: ROOTS_SEARCH,
  result: (searchTerm: string) => path(ROOTS_SEARCH, `/${searchTerm}`),
};
